import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AnswerBox from './AnswerBox';

export default class AnswerContainer extends Phaser.GameObjects.Container {
  static get ANSWER_CLICKED() {return 'answer_clicked';}


  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.answerBoxes = null;

    this.curAnswers = null;
    this.curCorrectIndex = null;

    this.isActive = false;

    this.answerBoxes = [];
    let curX = 0;
    for (let i = 0; i < 3; i++) {
      const item = new AnswerBox(this.scene);
      item.x = curX;
      curX += item.getBounds().width + 60;
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onClickAnswer(item));
      this.add(item);
      this.answerBoxes.push(item);
    }

    const bounds = this.getBounds();
    this.list.forEach((child) => {
      // eslint-disable-next-line no-param-reassign
      child.x -= bounds.width / 2;
      // eslint-disable-next-line no-param-reassign
      child.y -= bounds.height / 2;
    });
  }

  /**
   * 
   * @param {AnswerBox} answerBox 
   * @returns 
   */
  onClickAnswer (answerBox) {
    if (!this.isActive) return;

    const box = answerBox;
    if (box.beenClicked) {
      return;
    }
    const answerIndex = this.answers.indexOf(box.num);
    const c = answerIndex === this.curCorrectIndex;
    const dif = box.num - this.answers[this.curCorrectIndex];
    if (c) {
      this.isActive = false;
    }
    else {
      box.clickIncorrect();
    }
    const event = {};
    event.isCorrect = c;
    event.difference = dif;
    event.num = box.num;
    event.box = box;
    this.emit(AnswerContainer.ANSWER_CLICKED, event);
  }

  doneWithAnswers (correctBox) {
    const len = this.answerBoxes.length;
    for (let i = 0; i < len; i++) {
      if (this.answerBoxes[i] === correctBox) {
        this.answerBoxes[i].showCorrect();
      }
      else {
        this.answerBoxes[i].goOut();
      }
    }
  }

  initializeAnswerSet (answers, correctIndex) {
    this.answers = answers;
    this.curCorrectIndex = correctIndex;
    for (let i = 0; i < answers.length; i++) {
      this.answerBoxes[i].initWithValue(answers[i]);
      this.answerBoxes[i].comeIn();
    }
    this.isActive = true;
  }
}